<div class=" mt-4">
    <section>
        <div class="scrollmenu">
            <a [routerLink]="['/pos/businessinfo']"> Business-info </a>
            <a [routerLink]="['/pos/customer/new']"> Customer </a>
            <a [routerLink]="['/pos/Employee/new']"> Employee </a>
            <a [routerLink]="['/pos/orders/new']"> Orders</a>
            <a routerLinkActive = "active" class="active menu" [routerLink]="['/pos/taxfee/new']"> Tax Fee </a>
            <a [routerLink]="['/pos/category/new']"> Item-Category </a>
            <a [routerLink]="['/pos/item/new']"> Items </a>
            <a [routerLink]="['/pos/businesshour/new']"> Business-Hours </a>
            <!-- <a [routerLink]="['/pos/order/new']"> Order </a>
            <a [routerLink]="['/pos/orderreceipt/new']"> Order Receipt </a>
            <a [routerLink]="['/pos/payment/new']"> Payment </a>
            <a [routerLink]="['/pos/paymentrecipt/new']"> Payment Receipt </a>
            <a [routerLink]="['/pos/tip/new']"> Tips </a> -->

            <!--  <a [routerLink]="['/pos/orderregister']"> Order Register </a>  -->
            <!--  <a [routerLink]="['/pos/ordertype/new']"> Order Type </a> -->
            <!--   <a [routerLink]="['/pos/tender/new']">  Tender </a>  -->
        </div>

    </section>
    <section class="mt-2">
        <div class="">
            <div class="row">
                <div class="col-md-12">
                    <div class="text-right py-2">
                        <button class="dash-btns btn" [routerLink]="['/pos/taxfee/manage']">Manage Tax Fee</button>

                    </div>
                </div>
                <div class="col-md-7">
                    <div class="card-1">
                        <div class="row">
                            <div class="col-md-12">
                               
                                <div class="text-center">
                                    <!-- <a class="view-h gary-t mb-3">Tax Fee</a> -->
                                    <div class="col-md-12 " *ngIf="isNewTaxFee">
                                        <h4 class="font20 gary-t pt-3">Lets create a New Tax Fee here.</h4>
                                    </div>
                                    <div class="col-md-12 " *ngIf="isUpdateTaxFee">
                                        <h4 class="font20 gary-t pt-3">Update Tax Fee here.</h4>
                                    </div>




                                </div>

                                <div class="py-3">
                                    <form #fnewprepaidcard="ngForm">
                                        <div class="row mx-0">

                                            <div class="col-md-12" *ngIf="isNewTaxFee">

                                                <form #form="ngForm" class="addpaynow">
                                                    <div class="form-group">

                                                        <div class="row pt-2"> 
                                                            <div class="col-md-12">
                                                                <div class="form-group formgroup-tm">
                                                                    <label class="customlabel">Tax Fee Name *</label>
                                                                    <input type="text"
                                                                        class="formcontrol-user1 form-control"
                                                                        placeholder="TaxFee Name" id="TaxFeeName"
                                                                        name="TaxFeeName" [formControl]="TaxFeeName"  (change)=onChange()
                                                                        required>


                                                                </div>
                                                                 <span style="color:red;" *ngIf="taxfeenameerror">TaxFee Name already exist</span>
                      
                                                                <span class="text-danger"
                                                                    *ngIf="TaxFeeName.invalid && (TaxFeeName.dirty || TaxFeeName.touched)">{{taxfeeError()}}</span>

                                                            </div>
                                                        </div>

                                                        <div class="row pt-2"> 
                                                            <div class="col-md-12">
                                                                <div class="form-group formgroup-tm">
                                                                    <label class="customlabel">Tax Rate *</label>
                                                                    <input type="text"
                                                                        class="formcontrol-user1 form-control"
                                                                        placeholder="Tax Rate" id="TaxRate"
                                                                        name="TaxRate" [formControl]="TaxRate" required>
                                                                    <!-- <mat-error *ngIf="TaxRate.invalid">{{taxrateerrors()}}</mat-error> -->

                                                                </div>
                                                                <span class="text-danger"
                                                                    *ngIf="TaxRate.invalid && (TaxRate.dirty || TaxRate.touched)">{{taxrateerrors()}}
                                                                </span>
                                                            </div>
                                                        </div>


                                                        <div class="row pt-2 formgroup-tm">

                                                            <div class="col-md-5 col-lg-5">
                                                                <label  >IsDefault<span
                                                                        class="text-danger"></span></label>
                                                            </div>

                                                            <div class="col-md-6 col-lg-7">
                                                                <div class="">

                                                                    <input type="checkbox" [(ngModel)]="IsDefault"
                                                                        id="IsDefault" name="IsDefault"
                                                                        (checked)="Default1()">
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class=" pt-3">
                                                            <button class="btn dash-btns" type="button" id="savetaxfee"
                                                                color="primary"
                                                                [disabled]="TaxRate.invalid||TaxFeeName.invalid||taxfeenameerror"
                                                                (click)="taxfee()">Submit</button>

                                                        </div>

                                                    </div>
                                                </form>
                                            </div>
                                            <div class="col-md-12" *ngIf="isUpdateTaxFee">
                                                <form #form="ngForm" class="addpaynow">
                                                    <div class="form-group">

                                                        <div class="row pt-2"> 
                                                            <div class="col-md-12">
                                                                <div class="form-group formgroup-tm">
                                                                    <label class="customlabel">TaxFee Name *</label>
                                                                    <input type="text"
                                                                        class="formcontrol-user1 form-control"
                                                                        placeholder="TaxFee Name" id="TaxFeeName"
                                                                        (keydown)="onKey()"
                                                                        [(ngModel)]="rows.TaxFeeName" name="TaxFeeName"
                                                                        [formControl]="TaxFeeName" readonly required>


                                                                </div>
                                                                <span class="text-danger"
                                                                    *ngIf="TaxFeeName.invalid && (TaxFeeName.dirty || TaxFeeName.touched)">{{taxfeeError()}}</span>

                                                            </div>
                                                        </div>

                                                        <div class="row pt-2"> 
                                                            <div class="col-md-12">
                                                                <div class="form-group formgroup-tm">
                                                                    <label class="customlabel">Tax Rate *</label>
                                                                    <input type="text" class="formcontrol-user1 form-control"  placeholder="Tax Rate" id="TaxRate" name="TaxRate" (keydown)="onKey()"  [(ngModel)]="rows.TaxRate"  [formControl]="TaxRate" required>
                                                                    <!-- <mat-error *ngIf="TaxRate.invalid">{{taxrateerrors()}}</mat-error> -->

                                                                </div>
                                                                <span class="text-danger"
                                                                    *ngIf="TaxRate.invalid && (TaxRate.dirty || TaxRate.touched)">{{taxrateerrors()}}
                                                                </span>
                                                            </div>
                                                        </div>

                                                        <input type="hidden" [(ngModel)]="rows.Id" id="id" name="id"
                                                            [formControl]="id">
                                                            <input type="hidden" [(ngModel)]="rows.DateTime" id="date" name="date">
                                                        <div class="row pt-2 formgroup-tm">

                                                            <div class="col-md-5 col-lg-5">
                                                                <label>IsDefault<span
                                                                        class="text-danger"></span></label>
                                                            </div>

                                                            <div class="col-md-6 col-lg-7">
                                                                <div class="">

                                                                    <input type="checkbox" [(ngModel)]="IsDefault"
                                                                        id="IsDefault" name="IsDefault"
                                                                        (checked)="Default1()" (change)="onKey()">
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="  pt-3">
                                                            <button class="btn dash-btns" type="button" id="savetaxfee"
                                                                color="primary"
                                                                [disabled]="TaxRate.invalid||TaxFeeName.invalid || !isReadytoUpdatetaxfee"
                                                                (click)="updatetaxfee()">Update</button>

                                                        </div>

                                                    </div>
                                                </form>
                                            </div>

                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-5">
                    <div class="card p-2">
                        <div class="text-center">
                           <img src="https://fastswiff.com/assets/img/multiple-payment-options.png"   class="w-100" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

</div>






<!-- 
<section  >
    <div class="block-header">
        <div class="container">
            <div class="row ">
                <div class="col-md-12  p-0">
                    <h2 class="poppins font-weight-bold pl-2"> TaxFee</h2>
                </div>
                <div class=" col-md-5 px-6 col-sm-12 p-0">

                    <div class="breadcrumb flat">
                        <a [routerLink]="['/pos']">
                             Home
                        </a>
                        <a href="#" class="active">New TaxFee</a>
                    </div>
                </div>
                <div class="col-md-7">
                    <div class="float-right">

                     
                    </div>
                </div>
            </div>
        </div>

    </div>
    <div class="container">
        <div class="row">
            <div class="col-md-12 p-0">
                <div class=" card px-2 py-4 poppins border" style="box-shadow: none; border-radius: 10px;">
                    <div class="row mx-0">
                        
                    </div>
               
                </div>
            </div>
        </div>
    </div>
</section> -->